import { render, staticRenderFns } from "./ArticleBlockList.vue?vue&type=template&id=3158a9d3&scoped=true&"
import script from "./ArticleBlockList.vue?vue&type=script&lang=js&"
export * from "./ArticleBlockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158a9d3",
  null
  
)

export default component.exports